import { getTagsRequest } from "../../requests/tags";
export const types = {
  GET_TAGS_REQUEST: 'GET_TAGS_REQUEST',
  GET_TAGS_SUCCESS: 'GET_TAGS_SUCCESS',
  GET_TAGS_FAILURE: 'GET_TAGS_FAILURE'
}

export const getTags = () => {
  return (dispatch) => {
    dispatch({
      type: types.GET_TAGS_REQUEST
    })
    getTagsRequest()
      .then(response => {
        dispatch({
          type: types.GET_TAGS_SUCCESS,
          tags: response.data
        })
      })
      .catch(error=>{
        dispatch({
          type: types.GET_TAGS_FAILURE,
          error
        })
      })
  }
}